module.exports = __webpack_public_path__ + "img/145.0d3e8f6e.jpg";